import { SVGComponentProps } from "./utils/Types"

const ICircleIcon = ({ width = 20, height = 20, className }: SVGComponentProps) => {
    return (
        <svg
            className={`text-current ${className}`}
            width={width}
            height={height}
            viewBox="0 0 17 16"
            fill="none"
        >
            <path
                d="M8.50016 15.8333C4.12779 15.8333 0.583496 12.289 0.583496 7.91667C0.583496 3.54429 4.12779 0 8.50016 0C12.8725 0 16.4168 3.54429 16.4168 7.91667C16.4168 12.289 12.8725 15.8333 8.50016 15.8333ZM8.50016 14.25C10.1799 14.25 11.7908 13.5827 12.9785 12.395C14.1662 11.2073 14.8335 9.59637 14.8335 7.91667C14.8335 6.23696 14.1662 4.62605 12.9785 3.43832C11.7908 2.25059 10.1799 1.58333 8.50016 1.58333C6.82046 1.58333 5.20955 2.25059 4.02182 3.43832C2.83409 4.62605 2.16683 6.23696 2.16683 7.91667C2.16683 9.59637 2.83409 11.2073 4.02182 12.395C5.20955 13.5827 6.82046 14.25 8.50016 14.25ZM7.7085 3.95833H9.29183V5.54167H7.7085V3.95833ZM7.7085 7.125H9.29183V11.875H7.7085V7.125Z"
                fill="currentColor"
            />
        </svg>
    )
}

export default ICircleIcon
